'use client';

import MenuArrowDownIcon from '@/assets/icons/MenuArrowDown';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { cn } from '@/lib/utils';
import { useState } from 'react';

const CategorySidebar = ({ sections = [], activeCategory, setActiveCategory }) => {
  return (
    <div className=' border-r-2 pr-2 border-background shrink-0 max-w-80'>
      <ol className='category-sidebar hidden md:flex flex-col font-medium list-decimal'>
        {sections.map((section, index) => {
          const isActive = activeCategory === section.slug;
          return (
            <li key={index} onClick={() => setActiveCategory(section.slug)}>
              <div
                className={cn(
                  'h4 min-w-40 flex gap-4 items-center justify-between font-medium py-2 px-0 cursor-pointer transition-colors hover:text-secondary select-none flex-1',
                  {
                    'text-secondary': isActive
                  }
                )}
              >
                <div className="truncate">
                  {section.title}
                </div>
                <MenuArrowDownIcon
                  className={cn('-rotate-90 size-4 invisible ml-auto', {
                    visible: isActive
                  })}
                />
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
};

const CategorySelect = ({ sections = [], activeCategory, setActiveCategory }) => {
  return (
    <Select value={activeCategory} onValueChange={setActiveCategory} className='category-select'>
      <SelectTrigger className='md:hidden'>
        <SelectValue />
      </SelectTrigger>
      <SelectContent className='border-none'>
        {sections.map(section => (
          <SelectItem key={section.slug} value={section.slug}>
            {section.title}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default function GroupedFaqs({ sections = [], entries = [] }) {
  const [activeCategory, setActiveCategory] = useState(sections[0].slug);

  const activeEntry = entries.find(([slug]) => slug === activeCategory);
  const [, { list: faqs = [] }] = activeEntry;

  return (
    <div className='faq-group flex flex-col md:flex-row gap-4'>
      <CategorySidebar sections={sections} activeCategory={activeCategory} setActiveCategory={setActiveCategory} />

      <CategorySelect sections={sections} activeCategory={activeCategory} setActiveCategory={setActiveCategory} />

      <Accordion type='single' collapsible className='w-full'>
        {faqs.map(faq => (
          <AccordionItem key={faq.id} value={faq.id} className='border-none'>
            <AccordionTrigger className='py-2 w-full [&_svg]:text-secondary'>
              <span className='h5'>{faq.question}</span>
            </AccordionTrigger>
            <AccordionContent className='body1'>
              {faq.answer && <div className='prose' dangerouslySetInnerHTML={{ __html: faq.answer }} />}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
